import qs from 'qs'
import React from 'react'
import { merge } from 'lodash'

import { useEnvironment } from '@SonarCX/providers/EnvironmentProvider'
import { useAuth } from '@SonarCX/providers/AuthProvider'
import { APITaskData } from '@SonarCX/components/molecules/ReminderWidget'

type useDashboardRemindersOptions = {
  dateRangeStart: Date
  dateRangeEnd: Date
}

const useDashboardReminders = ({
  dateRangeStart,
  dateRangeEnd
}: useDashboardRemindersOptions) => {
  const { user, loaded: envLoaded } = useEnvironment()
  const { isLoggedIn } = useAuth()

  const userID = React.useMemo(() => user?.id, [user])
  const canLoad = React.useMemo(
    () => isLoggedIn && envLoaded && Boolean(userID),
    [isLoggedIn, envLoaded, userID]
  )

  const getKey = React.useCallback(
    (pageIndex: number, previousPageData: APITaskData) => {
      if (!canLoad) {
        return null
      }

      // Reached the end
      if (previousPageData && !previousPageData.data) {
        return null
      }

      // First page, we don't have `previousPageData`
      let pageNum = 0

      if (pageIndex !== 0) {
        // Add the cursor to the API endpoint
        pageNum = pageIndex + 1
      }
      let params = {}

      params = merge(params, {
        active_between_start: dateRangeStart.toISOString()
      })
      params = merge(params, {
        active_between_end: dateRangeEnd.toISOString()
      })
      const dateRanges = qs.stringify(params, { arrayFormat: 'brackets' })
      return `reminderDashboard:${pageNum}:${dateRanges}`
    },
    [canLoad, dateRangeStart, dateRangeEnd]
  )

  return {
    getKey
  }
}

export default useDashboardReminders
